// extracted by mini-css-extract-plugin
export default {"pointer":"pointer---tZcES"};